import React, { FC } from 'react';
import styled from 'src/theme';
import { usePresenter } from './usePresenter';

import { initRoofsData } from 'src/store/roofData/initRoofsData';
import { IRoofField } from 'src/store/roofData/types';

import {Col, Row, Tooltip} from "antd";
import {InputNumber} from "src/components/UI";

interface Props {}

export const Form: FC<Props> = () => {
  const presenter = usePresenter();

  const { fields } = initRoofsData[presenter.roofType];

  return (
    <div>
      <HeaderStyled>Размеры кровли</HeaderStyled>

      <Row gutter={[24 , 24]}>
        {
          fields.map(({ id, name, value, label, prefix, suffix, info }: IRoofField) => (
            <Col xs={12} key={id}>
              <Row>
                <ColumnLabelStyled xs={24}>
                  <Tooltip title={info}>
                    <LabelTextStyled>{label} <span dangerouslySetInnerHTML={{ __html: prefix, }} /> ({suffix})</LabelTextStyled>
                  </Tooltip>
                </ColumnLabelStyled>

                <Col xs={24}>
                  <InputNumber
                    value={presenter[name]}
                    onChange={presenter.changeRoofFieldValue[name]}
                    onFocus={() => presenter.changeFocusedField(name)}
                    onBlur={() =>  presenter.changeFocusedField(null)}
                    defaultValue={value}
                    style={{ width: '100%' }}
                    min={0.01}
                  /></Col>
              </Row>
            </Col>
          ))
        }
      </Row>
    </div>
  );
};

const HeaderStyled = styled.h4`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.nero};
`;

const ColumnLabelStyled = styled(Col)`
  display: flex;
  min-height: 35px;
  align-items: center;
`;

const LabelTextStyled = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #000000;
`;


